import * as N3 from "n3";
import { RdfTermType } from "../rdf-api.js";
import { DefaultGraphTermType, BlankNodeTermType, LiteralTermType, NamedNodeTermType, } from "rdflib/lib/types.js"; // Importing from non-standard export
export async function parseRdfQuadsWithN3(content) {
    return await n3Adapter(content, parseN3QuadAsRdfQuad);
}
async function n3Adapter(content, handler) {
    const parser = new N3.Parser();
    const quads = [];
    return new Promise((accept, reject) => {
        parser.parse(content, (error, quad) => {
            if (error !== null) {
                reject(error);
            }
            else if (quad === null) {
                accept(quads);
            }
            else {
                quads.push(handler(quad));
            }
        });
    });
}
function parseN3QuadAsRdfQuad(quad) {
    return {
        subject: parseTerm(quad.subject),
        predicate: parseTerm(quad.predicate),
        object: parseTerm(quad.object),
        graph: parseTerm(quad.graph),
    };
}
function parseTerm(term) {
    if (isNamedNode(term)) {
        return {
            termType: RdfTermType.NamedNode,
            value: term.value,
        };
    }
    if (isBlankNode(term)) {
        return {
            termType: RdfTermType.BlankNode,
            value: term.value,
        };
    }
    if (isLiteral(term)) {
        return {
            termType: RdfTermType.Literal,
            value: term.value,
            datatype: {
                termType: RdfTermType.NamedNode,
                value: term.datatype.value,
            },
            language: term.language,
        };
    }
    if (isDefaultGraph(term)) {
        return {
            termType: RdfTermType.DefaultGraph,
            value: "",
        };
    }
    throw new Error(`Unknown term type: ${term.termType}`);
}
const isNamedNode = (term) => term.termType === NamedNodeTermType;
const isBlankNode = (term) => term.termType === BlankNodeTermType;
const isLiteral = (term) => term.termType === LiteralTermType;
const isDefaultGraph = (term) => term.termType === DefaultGraphTermType;
//# sourceMappingURL=n3-adapter.js.map